// helpers.ts — Pure utility functions for L205 form

/** Convert ISO date string to HTML date input value (YYYY-MM-DD) */
export const dateToInput = (v: string | null | undefined): string => {
  if (!v) return '';
  return v.substring(0, 10);
};

/** Convert HTML date input value to ISO date string */
export const inputToDate = (v: string): string | null => {
  if (!v) return null;
  return v + 'T00:00:00Z';
};

/** Determine period (次別) from date: months 1-6 = 1 (上半年), 7-12 = 2 (下半年) */
export const getPeriodFromDate = (dateStr: string | null | undefined): number => {
  if (!dateStr) return 1;
  const month = parseInt(dateStr.substring(5, 7), 10);
  return month >= 1 && month <= 6 ? 1 : 2;
};

/** Fields that are always readonly */
const ALWAYS_READONLY = new Set([
  'fl150_01', // 查檢表號 (system generated)
  'fl150_15', // 總項數 (auto calculated)
]);

/** Determine if a field should be disabled */
export const isFieldDisabledFn = (key: string, isEditing: boolean, mode: string): boolean => {
  if (!isEditing) return true;
  if (ALWAYS_READONLY.has(key)) return true;
  // 次別 — only editable in add mode, locked in edit mode
  if (key === 'fl150_10' && mode === 'edit') return true;
  return false;
};
